//import liraries
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { COLORS, FONTS } from '../../constant';


// define your styles
const useStyles = CreateResponsiveStyle(
    {
        container: {
            width: "100%",  
        },
        bgImage: {
            width: 504,
            height: 430,
            paddingTop:50
        },
        bgImageMax: {
            width: 504,
            height: 430,
            paddingTop:50
        },
        termsTextWidget:{
            display:"none"
        },
        bannerTextWidget: {
            justifyContent: 'center',
            alignItems:'center',
            paddingHorizontal: 50,
        },
        bannerInnerTextWidgetMax:{
            marginBottom:20
        },
        bannerTextWidgetMax:{
            justifyContent: 'center',
            alignItems:'center',
            paddingHorizontal: 50,
            paddingTop: 40
        },
        bannerDescWidget:{
            alignItems:'center',
            width:'100%',
            textAlign:'center'
        },
        contentWrapper: {
            flexDirection: 'row',
            marginTop: 0,
            position:'relative'
        },
        benefitContainer: {
            alignItems: 'flex-start',
            width: '50%',
            paddingLeft:50,
            paddingTop:30
        },
        benefitContainerMax: {
            alignItems: 'flex-start',
            width: '50%',
            paddingLeft:50,
            paddingTop:30
        },
        benefitTextContainer: {
            width: '65%',
            marginTop: 20
        },
        memberShipWidget: {
            alignItems: 'center',
            marginTop: 30
        },
        memberShipWidgetMobile: {
            display: 'none'
        },
        termsTextWidgetLg: {
            textAlign: 'center',
            width: '80%'
        },
        overlayViewStyle: {
            position: "absolute",
            zIndex: 9999,
            backgroundColor: "rgba(52,52,52,0.9)",
            width: "100%",
            height: "100%",
            minHeight: 500,
            top: 0,
            left: 0,
            borderRadius: 10,
            alignItems: "center",
        },
        overlayContentStyle: {
            width: "80%",
            height: 400,
            backgroundColor: "white",
            borderRadius: 15,
            alignSelf: "center",
            justifyContent: "center",
            marginVertical: 30

        },
        pdfViewStyle: {
            padding: 0,
            height: 320,
            width: "100%",
        },
        termsText: {
            fontFamily: FONTS.Inter,
            fontSize: 13,
            color: COLORS.white,
            textAlign: 'center'
        },
        mPHomeHeaderPicStyle: {
            width: 259,
            height: 29,
            marginTop: -50,
            alignSelf: 'center'
        },
        cardViewStyle: {
            flexDirection: 'row',
            paddingHorizontal: 10,
            paddingVertical:10,
            marginRight: 10,
            marginBottom: 14,
            width: 300,
            height: 99,
            borderWidth: 1,
            borderColor: COLORS.boderColor,
            borderRadius: 10
        },
        vehicleViewStyle:{
            
        },
        flatListStyle: {
            height: 270,
            paddingBottom: 20,
            marginTop: 20,
            alignSelf:'center'
        },
        radiobuttonOutSideStyle: {
            width: 16,
            height: 16,
            borderRadius: 10,
            borderColor: "#ccd0d5",
            borderWidth: 2,
            alignItems: "center",
            justifyContent: "center",
            position:'absolute',
            right:20,
            top:44
        },
        radioButtonInsideStyle: {
            height: 8,
            width: 8,
            borderRadius: 8,
            backgroundColor: "#ccd0d5",
        },
        availBenfitBtn:{
            width:240,
            position:'absolute',
            right:30, 
            top:-66
        },
        availBenfitBtnMobile:{
            display:'none'
        },
        benefitTextHeader:{
            fontFamily: FONTS.Inter,
            fontSize: 15,
            color: "#757575",
            width:'100%'
          },
        notificationWidget:{
            backgroundColor:'#f0f9ff',
            borderRadius:14,
            padding:6,
            flexDirection:'row',
            marginTop:12,
            alignItems:'center'
        },
        notificationText:{
            fontFamily: FONTS.Inter,
            fontSize:11,
            color:COLORS.white
        },
        notificationCircle:{
            width:16,
            height:16,
            borderRadius:8,
            backgroundColor:COLORS.blue400,
            alignItems:'center',
            justifyContent:'center'
        }
    },

    {
        [DEVICE_SIZES.XL]: {
            container: {},
        },
        [DEVICE_SIZES.LG]: {
        },
        [DEVICE_SIZES.MD]: {
            container: {
                flexDirection: "column",
                minHeight: 600,
                paddingBottom:30
            },
            contentWrapper: {
                flexDirection: "column",
            },
            benefitContainer: {
                width: '100%',
                alignItems: 'flex-start',
                paddingLeft: 40,
                marginTop: 0
            },
            memberShipWidget: {
                display: 'none'
            },
            memberShipWidgetMobile: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 50,
                width: '70%'
            },
            termsTextWidget: {
                flexDirection: 'row',
                width: '70%',
                alignItems: 'center',
                display:"flex"
            },
            termsText: {
                marginTop: 20,
                color: COLORS.black,
                textAlign: 'center'
            },
            bgImage: {
                width: '100%',
                height: 230
            },
            bgImageMax:{
                width: '100%',
                height: 230
            },
            benefitContainerMax:{
                paddingLeft:10,
                width:'100%',
                alignItems:'center'
            },
            bannerTextWidgetMax:{
                paddingHorizontal:10,
                flexDirection:'row-reverse',
                flexWrap: 'wrap',
                justifyContent:'space-around'
            },
            bannerInnerTextWidgetMax:{
                marginBottom:0
            },
            bannerDescWidget:{
                paddingTop:10
            },
            availBenfitBtn:{
                display:'none'
            },
            availBenfitBtnMobile:{
                display:'flex',
                marginTop:15,
                width:210,
                alignSelf:'center'
            },

        },
        [DEVICE_SIZES.SM]: {
            container: {
                flexDirection: "column",
            },
            contentWrapper: {
                flexDirection: "column",
            },
            benefitContainer: {
                width: '100%',
                alignItems: 'flex-start',
                paddingLeft:20,
                paddingTop:0
            },
            benefitTextContainer: {
                width: '95%',
            },
            bannerTextWidget: {
                paddingHorizontal: 10,
                paddingTop: 10
            },
            memberShipWidget: {
                display: 'none'
            },
            mPHomeHeaderPicStyle: {
                marginTop: -70,
            },
            memberShipWidgetMobile: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 50
            },
            termsTextWidget: {
                flexDirection: 'row',
                display:"flex"
            },
            termsText: {
                color: COLORS.black,
                textAlign: 'center'
            },
            benefitContainerMax:{
                paddingLeft:10,
                width:'100%'
            },
            bannerTextWidgetMax:{
                paddingHorizontal:10,
                flexDirection:'row-reverse',
                flexWrap: 'wrap',
                justifyContent:'space-between'
            },
            bannerInnerTextWidgetMax:{
                marginBottom:0
            },
            bannerDescWidget:{
                paddingTop:10
            },
            availBenfitBtn:{
                display:'none'
            },
            availBenfitBtnMobile:{
                display:'flex',
                marginTop:15
            },
            notificationWidget:{
                width:'96%',
                marginTop:20
            }
        },
        [DEVICE_SIZES.XS]: {
            container: {
                width: "100%",
                // backgroundColor:'#f3f3f3'
            },
            overlayContentStyle: {
                width: "90%",
            },
            contentWrapper: {
                flexDirection: "column",
            },
            benefitContainer: {
                width: '100%',
                alignItems: 'flex-start',
                paddingLeft:20,
                paddingTop:0
            },
            benefitTextContainer: {
                width: '90%',
                paddingLeft: 20
            },
            bgImage: {
                width: '100%',
                height: 240,
            },
            bgImageMax:{
                width: '100%',
                height: 240,
                paddingTop:10
            },
            bannerTextWidget: {
                paddingHorizontal: 10,
                paddingTop: 10
            },
            memberShipWidget: {
                display: 'none'
            },
            mPHomeHeaderPicStyle: {
                marginTop: -70,
            },
            memberShipWidgetMobile: {
                display: 'flex',
                alignItems: 'center',
                marginTop: 50
            },
            termsText: {
                color: COLORS.black,
                textAlign: 'center'
            },
            termsTextWidget: {
                flexDirection: 'row',
                display:"flex",
                paddingHorizontal:15
            },
            benefitContainerMax:{
                paddingLeft:10,
                width:'100%'
            },
            bannerTextWidgetMax:{
                paddingHorizontal:10,
                flexDirection:'row-reverse',
                flexWrap: 'wrap',
                justifyContent:'space-between'
            },
            bannerInnerTextWidgetMax:{
                marginBottom:0
            },
            bannerDescWidget:{
                paddingTop:10
            },
            availBenfitBtn:{
                display:'none'
            },
            availBenfitBtnMobile:{
                display:'flex',
                marginTop:15,
                width:"80%",
                alignSelf:"center"
            },
            cardViewStyle: {
                paddingHorizontal: 10,
                width: 300,
            },
            notificationWidget:{
                width:'96%',
                marginTop:20
            }
        },

    }
);
//make this component available to the app
export default useStyles;
